export const sanitizeInput = (input) => {
	return input.replace(/[^a-zA-Z0-9\s-]/g, ""); // Allow only letters, numbers, spaces, and hyphens
};
